import { Navigate, useLocation } from 'react-router-dom';
import { useAppStore } from '../store/useAppStore';

type Props = { children: React.ReactNode };

/**
 * Redirects to /login when there is no Supabase-backed session in the app store.
 */
export function RequireAuth({ children }: Props) {
  const isAuthenticated = useAppStore((s) => s.isAuthenticated);
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }

  return <>{children}</>;
}
